module.exports = __webpack_public_path__ + "static/1-39552acc1e67de676b5165b482b06d88.svg";